import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["items"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import i18n from "@Shared/@i18n";
import { denormalize } from "normalizr";
import { MONTHS_NAMES } from "@Shared/utils/constants";
import { getField } from "@joandvgv/vuex-map-fields";
import { defaultSelectedBoard } from "./board-default-state";
import { collaboratorsSchema, timelineSchema, emailTemplatesSchema, checklistTemplatesSchema } from "./board-schema";
import defaultState from "./client-profile-default-state";
import Vue from "vue";
import { snakeUppercase } from "@Shared/@Utils/utils";
import { groupBy, isEmpty, kebabCase, orderBy } from "lodash";
export const BOARDS = "BOARDS";
export const COLLABORATORS = "COLLABORATORS";
export const SELECTED_BOARD = "SELECTED_BOARD";
export const PROFILES = "PROFILES";
export const ACTIVE_PROFILES = "ACTIVE_PROFILES";
export const STATUSES = "STATUSES";
export const FIRST_COLUMN = "FIRST_COLUMN";
export const COLLABORATOR_USERNAMES = "COLLABORATOR_USERNAMES";
export const COLLABORATION_ID = "COLLABORATION_ID";
export const CUSTOM_FIELDS_DEFINITIONS = "CUSTOM_FIELDS_DEFINITIONS";
export const DEFAULT_ASSIGNEES = "DEFAULT_ASSIGNEES";
export const DEFAULT_ASSIGNEES_USERNAMES = "DEFAULT_ASSIGNEES_USERNAMES";
export const CLIENT_PROFILE_OWNER = "CLIENT_PROFILE_OWNER";
export const SELECTED_BOARD_TRACK_EMAILS = "SELECTED_BOARD_TRACK_EMAILS";
export const BOARD_OWNER = "BOARD_OWNER";
export const BOARD_OWNER_BY_BOARD_ID = "BOARD_OWNER_BY_BOARD_ID";
export const CUSTOM_FIELD_DROPDOWN_VALUE = "CUSTOM_FIELD_DROPDOWN_VALUE";
export const SELECTED_BOARD_FILTERS = "SELECTED_BOARD_FILTERS";
export const CUSTOM_FIELDS_TRANSLATION_MAP = "CUSTOM_FIELDS_TRANSLATION_MAP";
export const INACTIVE_CLIENTS_LOADED = "INACTIVE_CLIENTS_LOADED";
export const INACTIVE_TABLE_FILTER_BOARD_IDS = "INACTIVE_TABLE_FILTER_BOARD_IDS";
export const GET_EMAIL_TEMPLATES = "GET_EMAIL_TEMPLATES";
export const GET_CHECKLIST_TEMPLATES = "GET_CHECKLIST_TEMPLATES";
export const GET_CLIENT_PROFILE_LISTS = "GET_CLIENT_PROFILE_LISTS";
export const GET_CLIENT_PROFILE_CAMPAIGNS = "GET_CLIENT_PROFILE_CAMPAIGNS";
export const CLIENT_PROFILE_CO_APPLICANTS = "CLIENT_PROFILE_CO_APPLICANTS";
export const CLIENT_PROFILE_CUSTOM_FIELDS_TAGS = "CLIENT_PROFILE_CUSTOM_FIELDS_TAGS";
export const GET_BOARD_STATUSES = "GET_BOARD_STATUSES";
export const CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS = "CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS";
export const GET_DEFAULT_CUSTOM_FIELD = "GET_DEFAULT_CUSTOM_FIELD";
export const CLIENT_PROFILES_BY_BOARD = "CLIENT_PROFILES_BY_BOARD";
export const GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED = "GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED";
export const GET_PROFILE_PARTICIPANTS = "GET_PROFILE_PARTICIPANTS";
const getters = {
  getField,
  [DEFAULT_ASSIGNEES]: state => (boardId, clientProfileId) => {
    const profile = state.clientProfiles.byId[clientProfileId];
    const owner = profile && profile.owner || {};
    const currentUser = Vue.auth.session.get().userDetails;
    if (isEmpty(owner)) return [currentUser];
    return owner.username === currentUser.username ? [owner] : [owner, currentUser];
  },
  [DEFAULT_ASSIGNEES_USERNAMES]: (state, getters) => (boardId, clientProfileId) => {
    var _context;
    return _mapInstanceProperty(_context = getters.DEFAULT_ASSIGNEES(boardId, clientProfileId)).call(_context, ({
      username
    }) => username);
  },
  [CLIENT_PROFILE_OWNER]: state => (boardId, clientProfileId) => {
    const profile = state.clientProfiles.byId[clientProfileId];
    return profile && profile.owner || {};
  },
  [BOARDS]: state => {
    if (isEmpty(state.boards.byId)) return [];
    const {
      byId
    } = state.boards;
    return _Object$values(byId);
  },
  [COLLABORATORS]: state => boardId => {
    const collaborators = state.collaborators || {};
    if (isEmpty(collaborators[boardId])) return {};
    return collaborators[boardId].byId || {};
  },
  [COLLABORATION_ID]: state => (boardId, username) => {
    var _collaborator$collabo;
    const collaborators = state.collaborators || {};
    if (isEmpty(collaborators[boardId])) return null;
    const collaborator = collaborators[boardId].byId[username];
    return (_collaborator$collabo = collaborator == null ? void 0 : collaborator.collaborationId) != null ? _collaborator$collabo : null;
  },
  [COLLABORATOR_USERNAMES]: state => boardId => {
    const collaborators = state.collaborators || [];
    if (isEmpty(collaborators[boardId])) return [];
    return collaborators[boardId].allIds || [];
  },
  [SELECTED_BOARD]: state => {
    const {
      selectedBoardId,
      boards
    } = state;
    return boards.byId[selectedBoardId] || defaultSelectedBoard;
  },
  [SELECTED_BOARD_TRACK_EMAILS]: (state, getters) => username => {
    var _selectedBoard$trackE, _selectedBoardCollabo, _selectedBoardCollabo2;
    const selectedBoard = getters.SELECTED_BOARD;
    if (selectedBoard.owner) return (_selectedBoard$trackE = selectedBoard == null ? void 0 : selectedBoard.trackEmails) != null ? _selectedBoard$trackE : false;
    const selectedBoardCollaborators = getters.COLLABORATORS(selectedBoard.id);
    return (_selectedBoardCollabo = (_selectedBoardCollabo2 = selectedBoardCollaborators[username]) == null ? void 0 : _selectedBoardCollabo2.trackEmails) != null ? _selectedBoardCollabo : false;
  },
  [PROFILES]: state => {
    return state.clientProfiles || {};
  },
  [ACTIVE_PROFILES]: state => {
    var _context2;
    return _reduceInstanceProperty(_context2 = state.clientProfiles.allIds).call(_context2, (acc, clientProfileId) => {
      const clientProfile = state.clientProfiles.byId[clientProfileId];
      if (clientProfile.active) {
        acc.byId[clientProfileId] = clientProfile;
        acc.allIds.push(clientProfileId);
      }
      return acc;
    }, {
      byId: {},
      allIds: []
    });
  },
  [STATUSES]: state => {
    const {
      selectedBoardId,
      boardsStatuses
    } = state;
    return boardsStatuses[selectedBoardId] || {};
  },
  [FIRST_COLUMN]: state => {
    var _boards$byId$selected, _boards$byId$selected2, _boardsStatuses$selec, _boardsStatuses$selec2;
    const {
      selectedBoardId,
      boardsStatuses,
      boards
    } = state;
    if (isEmpty(boards)) return null;
    const [firstColumnId] = (_boards$byId$selected = (_boards$byId$selected2 = boards.byId[selectedBoardId]) == null ? void 0 : _boards$byId$selected2.order) != null ? _boards$byId$selected : [];
    const columns = (_boardsStatuses$selec = (_boardsStatuses$selec2 = boardsStatuses[selectedBoardId]) == null ? void 0 : _boardsStatuses$selec2.byId) != null ? _boardsStatuses$selec : {};
    return firstColumnId && columns[firstColumnId] || null;
  },
  [CUSTOM_FIELDS_DEFINITIONS]: state => boardId => {
    var _state$boardsCustomFi, _state$boardsCustomFi2;
    return (_state$boardsCustomFi = (_state$boardsCustomFi2 = state.boardsCustomFieldsDefinitions) == null ? void 0 : _state$boardsCustomFi2[boardId]) != null ? _state$boardsCustomFi : {};
  },
  [BOARD_OWNER]: state => {
    const {
      selectedBoardId
    } = state;
    return state.boards.byId[selectedBoardId].ownerDetails;
  },
  [BOARD_OWNER_BY_BOARD_ID]: state => boardId => {
    var _state$boards$byId$bo, _state$boards$byId$bo2;
    return (_state$boards$byId$bo = (_state$boards$byId$bo2 = state.boards.byId[boardId]) == null ? void 0 : _state$boards$byId$bo2.ownerDetails) != null ? _state$boards$byId$bo : null;
  },
  [CUSTOM_FIELD_DROPDOWN_VALUE]: state => (boardId, customDefinitionId, itemSelectedId) => {
    var _state$boardsCustomFi3, _context3;
    const selectedItem = (_state$boardsCustomFi3 = state.boardsCustomFieldsDefinitions[boardId].byId[customDefinitionId].options) == null ? void 0 : _findInstanceProperty(_context3 = _state$boardsCustomFi3.items).call(_context3, item => item.id === itemSelectedId);
    return selectedItem ? selectedItem.name : i18n.t("global.words.notSelected").toString();
  },
  [SELECTED_BOARD_FILTERS]: state => {
    const {
      selectedBoardId,
      defaultFilters
    } = state;
    return _objectSpread(_objectSpread({}, defaultFilters), state.boards.byId[selectedBoardId].clientBoardFilter);
  },
  [CUSTOM_FIELDS_TRANSLATION_MAP]: state => boardId => {
    return state.customFieldsTranslationMap[boardId];
  },
  [INACTIVE_CLIENTS_LOADED]: state => {
    return state.inactiveTable.inactiveClientProfiles.allIds.length;
  },
  [INACTIVE_TABLE_FILTER_BOARD_IDS]: state => {
    return state.inactiveTable.inactiveTableFilters.boardIds;
  },
  getProfileCollaborators: state => ({
    id
  }) => {
    if (!state.clientProfiles.byId[id]) return [];
    const {
      collaborators
    } = state.clientProfiles.byId[id];
    const {
      allIds,
      byId
    } = collaborators;
    return denormalize(allIds, [collaboratorsSchema], {
      collaborators: byId
    });
  },
  profileCustomFields: state => id => {
    const {
      customFields
    } = state.clientProfiles.byId[id] || defaultState();
    return customFields;
  },
  [GET_EMAIL_TEMPLATES]: state => {
    const {
      emailTemplates
    } = state;
    const {
      allIds,
      byId
    } = emailTemplates || {};
    if (isEmpty(byId)) return [];
    return denormalize(allIds, [emailTemplatesSchema], {
      emailTemplates: byId
    });
  },
  [GET_CHECKLIST_TEMPLATES]: state => {
    const {
      checklistTemplates
    } = state;
    const {
      allIds,
      byId
    } = checklistTemplates || {};
    if (isEmpty(byId)) return [];
    return denormalize(allIds, [checklistTemplatesSchema], {
      checklistTemplates: byId
    });
  },
  getProfileStatusLabelId: state => ({
    id
  }) => {
    const profile = state.clientProfiles.byId[id];
    return profile ? profile.statusLabelId : null;
  },
  getProfileOwner: state => id => {
    const profile = state.clientProfiles.byId[id];
    return profile && profile.owner || {};
  },
  [GET_PROFILE_PARTICIPANTS]: state => id => {
    const profile = state.clientProfiles.byId[id];
    return profile && profile.participants || [];
  },
  getDefaultAssignees: state => id => {
    const profile = state.clientProfiles.byId[id];
    const owner = (profile == null ? void 0 : profile.owner) || null;
    const currentUser = Vue.auth.session.get().userDetails;
    if (!owner) return [currentUser];
    return owner.username === currentUser.username ? [owner] : [owner, currentUser];
  },
  progressStates: state => id => {
    var _statusLabels$;
    if (isEmpty(state.clientProfiles.byId[id])) return [];
    const {
      statusLabels
    } = state.clientProfiles.byId[id];
    const {
      boardId
    } = (_statusLabels$ = statusLabels == null ? void 0 : statusLabels[0]) != null ? _statusLabels$ : {};
    const board = state.boards.byId[boardId];
    if (board) {
      var _context4;
      const labelsById = groupBy(statusLabels, "id");
      return _mapInstanceProperty(_context4 = board.order).call(_context4, id => {
        const [{
          label
        }] = labelsById[id];
        return {
          id,
          value: label
        };
      });
    }
    return statusLabels == null ? void 0 : _mapInstanceProperty(statusLabels).call(statusLabels, ({
      id,
      label
    }) => ({
      id,
      value: label
    }));
  },
  getTimeline: state => id => {
    var _context6, _context7;
    if (isEmpty(state.clientProfiles.byId[id])) return [];
    const PINNABLE_TABS = ["follow-up", "note", "checklist"];
    const PINNED_INDEX = 0;
    const SCHEDULED_INDEX = 1;
    const {
      timeline
    } = state.clientProfiles.byId[id];
    const unparsedTimeline = denormalize(timeline.allIds, [timelineSchema], {
      timeline: timeline.byId
    });
    if (!unparsedTimeline.length) return [];
    const sectionIndexes = {};
    const dripCampaignsIds = {};
    const parsedTimeline = _reduceInstanceProperty(unparsedTimeline).call(unparsedTimeline, (parsedTimeline, timelineItem, _, unparsed) => {
      const {
        activityType,
        createdAt,
        updatedAt,
        complete,
        pinned,
        automationType,
        campaignId
      } = timelineItem;
      if (activityType === "follow-up" && !complete) {
        parsedTimeline[SCHEDULED_INDEX].items.push(timelineItem);
      } else {
        var _context5;
        const timestampUTC = _includesInstanceProperty(_context5 = ["account-creation", "file", "email", "event"]).call(_context5, activityType) ? createdAt : updatedAt;
        const dateObject = new Date(timestampUTC);
        const month = `${MONTHS_NAMES()[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
        const timestamp = dateObject.getTime();
        const index = sectionIndexes[month];
        const itemToAdd = [timelineItem];
        const isDrip = automationType === "drip-campaign";
        const shouldDuplicateDrip = isDrip && !dripCampaignsIds[campaignId];
        if (shouldDuplicateDrip) {
          const stages = _reduceInstanceProperty(unparsed).call(unparsed, (acc, item) => {
            if (item.automationType === "drip-campaign" && item.campaignId === campaignId) {
              acc.push(_parseInt(item.stageId));
            }
            return acc;
          }, []);
          const firstStage = Math.min(...stages);
          const itemToPush = _findInstanceProperty(unparsed).call(unparsed, ({
            stageId
          }) => _parseInt(stageId) === firstStage);
          itemToAdd.unshift(_objectSpread(_objectSpread({}, itemToPush), {}, {
            addition: true,
            sent: undefined,
            activityType: "drip-campaign-creation"
          }));
          dripCampaignsIds[campaignId] = true;
        }
        if (index >= 0) {
          parsedTimeline[index].items.push(...itemToAdd);
        } else {
          parsedTimeline.push({
            sectionName: month,
            items: [...itemToAdd],
            timestamp
          });
          sectionIndexes[month] = parsedTimeline.length - 1;
        }
      }
      if (pinned && _includesInstanceProperty(PINNABLE_TABS).call(PINNABLE_TABS, activityType)) {
        parsedTimeline[PINNED_INDEX].items.push(timelineItem);
      }
      return parsedTimeline;
    }, [{
      sectionKey: "pinned",
      sectionName: i18n.t("client-profile.pinned"),
      items: [],
      timestamp: 0
    }, {
      sectionKey: "scheduled",
      sectionName: i18n.t("client-profile.scheduled"),
      items: [],
      timestamp: 0
    }]);
    const parsedWithEmailThreads = _mapInstanceProperty(_context6 = _sortInstanceProperty(_context7 = _mapInstanceProperty(parsedTimeline).call(parsedTimeline, monthTimeline => {
      var _context8;
      monthTimeline.items = _reduceInstanceProperty(_context8 = monthTimeline.items).call(_context8, (parsedByMonth, activity) => {
        if (activity.activityType === "email") {
          var _context9, _context0;
          const {
            createdAt,
            updatedAt,
            threadId,
            activityType,
            from
          } = activity;
          const splittedFrom = from.split("<");
          activity.fromName = _trimInstanceProperty(_context9 = splittedFrom[0] || "").call(_context9);
          activity.fromEmail = _trimInstanceProperty(_context0 = splittedFrom[1] || splittedFrom[0] || "").call(_context0).replace(">", "");
          const threadIndex = _findIndexInstanceProperty(parsedByMonth).call(parsedByMonth, thread => activity.threadId && thread.threadId === activity.threadId);
          if (threadIndex >= 0) {
            parsedByMonth[threadIndex].threadEmails.push(activity);
          } else {
            parsedByMonth.push({
              activityType,
              threadId,
              threadEmails: [activity],
              createdAt,
              updatedAt
            });
          }
        } else {
          parsedByMonth.push(activity);
        }
        return parsedByMonth;
      }, []);
      return monthTimeline;
    })).call(_context7, ({
      sectionKey: sectionKeyA,
      timestamp: timestampA
    }, {
      sectionKey: sectionKeyB,
      timestamp: timestampB
    }) => {
      if (sectionKeyA === "pinned") return -1;
      if (sectionKeyB === "pinned") return 1;
      if (sectionKeyA === "scheduled") return -1;
      if (sectionKeyB === "scheduled") return 1;
      return timestampB - timestampA;
    })).call(_context6, monthTimeline => {
      var _context1;
      const timestamps = {
        automation: "updatedAt",
        note: "updatedAt",
        checklist: "updatedAt",
        "follow-up": "updatedAt",
        "client-application-request": "updatedAt"
      };
      const filteredItems = _filterInstanceProperty(_context1 = monthTimeline.items).call(_context1, ({
        sent,
        deleted
      }) => typeof sent === "undefined" || sent || deleted);
      const items = orderBy(filteredItems, [function (activity) {
        return activity[timestamps[activity.activityType] || "createdAt"];
      }, "addition"], ["desc", "desc"]);
      return _objectSpread(_objectSpread({}, monthTimeline), {}, {
        items
      });
    });
    const scheduled = parsedWithEmailThreads[1].items;
    if (!isEmpty(scheduled)) {
      parsedWithEmailThreads[1].items = orderBy(scheduled, "scheduledDate", "asc");
    }
    return parsedWithEmailThreads;
  },
  filterTimelineList: (state, getters) => ({
    id,
    filter
  }) => {
    const timeline = getters.getTimeline(id);
    if (filter === "pinned") {
      return _filterInstanceProperty(timeline).call(timeline, ({
        sectionKey
      }) => sectionKey === "pinned");
    }
    return _mapInstanceProperty(timeline).call(timeline, _ref => {
      let {
          items
        } = _ref,
        monthTimeline = _objectWithoutProperties(_ref, _excluded);
      return _objectSpread(_objectSpread({}, monthTimeline), {}, {
        items: _filterInstanceProperty(items).call(items, timeline => {
          if (filter === "automation") {
            return timeline.automationType;
          }
          return filter === "all" || timeline.activityType === filter;
        })
      });
    });
  },
  getDetails: state => id => {
    const profile = state.clientProfiles.byId[id] || defaultState();
    return getField(profile);
  },
  getChangeLog: state => id => {
    if (isEmpty(state.clientProfiles.byId[id])) return [];
    const {
      changelog
    } = state.clientProfiles.byId[id];
    const changelogWithoutUnknown = _filterInstanceProperty(changelog).call(changelog, c => c.type !== "unknown" || c.field !== "unknown");
    const changelogWithMonth = _reduceInstanceProperty(changelogWithoutUnknown).call(changelogWithoutUnknown, (acc, curr) => {
      const dateObject = new Date(curr.insertionTimestamp);
      const month = `${MONTHS_NAMES()[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
      if (acc[month]) {
        acc[month].items.push(curr);
      } else {
        acc[month] = {
          sectionName: month,
          sectionKey: kebabCase(month),
          timestamp: curr.insertionTimestamp,
          items: [curr]
        };
      }
      return acc;
    }, {});
    return orderBy(_Object$values(changelogWithMonth), ["timestamp"], ["desc"]);
  },
  emailTemplates: state => {
    const {
      emailTemplates
    } = state;
    const {
      allIds,
      byId
    } = emailTemplates;
    return denormalize(allIds, [emailTemplatesSchema], {
      emailTemplates: byId
    });
  },
  checklistTemplates: state => {
    const {
      checklistTemplates
    } = state;
    const {
      allIds,
      byId
    } = checklistTemplates || {};
    if (isEmpty(byId)) return [];
    return denormalize(allIds, [checklistTemplatesSchema], {
      checklistTemplates: byId
    });
  },
  [GET_CLIENT_PROFILE_LISTS]: state => clientProfileId => {
    return _Object$values(state.lists[clientProfileId] || {});
  },
  [GET_CLIENT_PROFILE_CAMPAIGNS]: state => clientProfileId => {
    return _Object$values(state.campaigns[clientProfileId] || {});
  },
  [CLIENT_PROFILE_CO_APPLICANTS]: state => clientProfileId => {
    var _state$clientProfiles;
    return ((_state$clientProfiles = state.clientProfiles.byId[clientProfileId]) == null ? void 0 : _state$clientProfiles.coApplicants) || [];
  },
  [CLIENT_PROFILE_CUSTOM_FIELDS_TAGS]: (state, getters) => clientProfileId => {
    var _context10;
    return _mapInstanceProperty(_context10 = getters.profileCustomFields(clientProfileId)).call(_context10, ({
      name,
      type
    }) => {
      return {
        name: snakeUppercase(name),
        type
      };
    });
  },
  [CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS]: (state, getters) => clientProfileId => {
    var _context11;
    return _mapInstanceProperty(_context11 = getters.profileCustomFields(clientProfileId)).call(_context11, ({
      name
    }) => snakeUppercase(name));
  },
  [GET_BOARD_STATUSES]: state => boardId => {
    const {
      boardsStatuses
    } = state;
    return boardsStatuses[boardId] || {};
  },
  [GET_DEFAULT_CUSTOM_FIELD]: state => (id, fieldName) => {
    var _context12;
    const profile = state.clientProfiles.byId[id];
    if (!profile) return "";
    const customField = _findInstanceProperty(_context12 = profile.customFields).call(_context12, x => x.name === fieldName);
    return (customField == null ? void 0 : customField.value) || "";
  },
  [CLIENT_PROFILES_BY_BOARD]: state => boardId => {
    var _state$boards$byId$bo3;
    return ((_state$boards$byId$bo3 = state.boards.byId[boardId]) == null ? void 0 : _state$boards$byId$bo3.boardProfiles) || [];
  },
  [GET_CLIENT_PROFILE_MASTER_UNSUBSCRIBED]: state => clientProfileId => {
    const profile = state.clientProfiles.byId[clientProfileId];
    if (!profile) return null;
    return profile.masterUnsubscribed;
  }
};
export default getters;